<div class="layout-ParentDiv innerDiv editeUser addCoach">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="coachForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div
                                class="p-field p-col-12 div-border p-p-0 d-flex align-items-center justify-content-between">
                                <h3 class="head-page-title">
                                    {{pagetitle}}
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-6">
                                    <label for="name">first NAME <span class="mandatory-fields">*</span></label>
                                    <input placeholder="Enter coach first name" formControlName="firstName" type="text"
                                        pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                                    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                        <div *ngIf="f.firstName.errors.required">First Name is required.</div>
                                        <div *ngIf="!f.firstName.errors.required">Numbers, Space and Special characters
                                            not allowed.</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-6">
                                    <label for="name">last NAME <span class="mandatory-fields">*</span></label>
                                    <input placeholder="Enter coach last name" formControlName="lastName" type="text"
                                        pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                    <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                        <div *ngIf="f.lastName.errors.required">lastName is required.</div>
                                        <div *ngIf="!f.lastName.errors.required">Numbers, Space and Special characters
                                            not allowed.</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown ">
                                    <label for="totalCoaches">Role</label>
                                    <p-dropdown inputId="totalCoaches" formControlName="designationId" [filter]="true"
                                        placeholder="Select" [options]="coachDesignations" optionLabel="name"
                                        optionValue="id" appendTo="body"
                                        [ngClass]="{ 'is-invalid': submitted && f.designationId.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.designationId.errors" class="invalid-feedback">
                                        <div *ngIf="f.designationId.errors.required">Designation is required.</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 numberform">
                                    <label for="mobilenumber">MOBILE NUMBER <span
                                            class="mandatory-feilds">*</span></label>
                                    <div class="Phone form-lable ">
                                        <span class=" w-100">
                                            <div class="mobile0numberField d-flex  ">
                                                <div class="countryCode addFormDropDown">
                                                    <p-dropdown inputId="phoneCode" formControlName="phoneCode"
                                                        appendTo="body" [options]="countryCodeList"
                                                        optionLabel="phone_code" optionValue="phone_code"
                                                        [filter]="true">
                                                        <ng-template pTemplate="selectedItem" let-selectedOption>
                                                            <div class="flex justify-content-center align-items-center"
                                                                style="display: flex;">
                                                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                                                    [class]="'flag flag-' + selectedOption.code.toLowerCase()"
                                                                    style="width: 18px" />
                                                                <div class="ml-2">{{ selectedOption.phone_code }}</div>
                                                            </div>
                                                        </ng-template>
                                                        <ng-template let-country pTemplate="item">
                                                            <div class="flex align-items-center" style="display: flex;">
                                                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                                                    [class]="'flag flag-' + country.code.toLowerCase()"
                                                                    style="width: 18px" />&nbsp;&nbsp;
                                                                <span class="ml-2">{{ country?.phone_code }}</span>
                                                            </div>
                                                        </ng-template>
                                                    </p-dropdown>
                                                </div>
                                                <p-inputNumber mode="decimal" [useGrouping]="false"
                                                    formControlName="mobileNumber" [maxlength]="10" required
                                                    placeholder="Enter your mobile number"
                                                    [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }"></p-inputNumber>

                                            </div>
                                        </span>
                                        <div class="d-flex">
                                            <div *ngIf="submitted && f.mobileNumber.errors"
                                                class="invalid-feedback d-block">
                                                <div *ngIf="f.mobileNumber.errors.required">MobileNumber is required.
                                                </div>
                                                <div *ngIf="f.mobileNumber.errors">Please Check Mobile Number</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="p-field p-col-4">
                                    <label for="email">email <span class="mandatory-fields">*</span></label>
                                    <input formControlName="email" type="email" pInputText
                                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Email is required.</div>
                                        <div *ngIf="f.email.errors.email">Enter Valid Email Address</div>
                                    </div>
                                </div> -->

                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">

                                        <div class="p-field p-col-2" *ngIf="id">
                                            <div class="statusdiv">
                                                <label for="status">Status</label>
                                                <p-inputSwitch formControlName="status"></p-inputSwitch>
                                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                                    <div *ngIf="f.status.errors.required">Please Select Status</div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end">
                            <div class="p-formgrid p-grid">
                                <p-toast></p-toast>
                                <button type="submit" pButton icon="pi pi-check"
                                    [label]="(!id) ? 'Add Coach' : 'Update Coach'" (click)="onSubmitCoachForm()"
                                    class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                                <button type="button" (click)="backLink()" pButton icon="pi pi-times" label="back"
                                    class="p-button-danger cancel-btn" style="width: auto"></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>